import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

//import constants
import { AppSettings } from '../../../../constants/app-settings';
import { AppFrontRoutes } from '../../../../constants/app-front-routes';

//import services
import { GeneralService } from '../../../../services/general.service';
import { TicketService } from '../../../../services/ticket.service';

@Component({
  selector: 'app-support-ticket-create',
  templateUrl: './support-ticket-create.component.html',
  styleUrls: ['./support-ticket-create.component.css']
})
export class SupportTicketCreateComponent implements OnInit {

  readonly AppSettings = AppSettings;
  readonly AppFrontRoutes = AppFrontRoutes;

  data: any;
  lang: any;
  categories: any;

  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;

  ckeditorOptions: any;

  constructor(
    private formBuilder: FormBuilder,
    private generalService: GeneralService,
    private ticketService: TicketService,
    private router: Router,
  ) { }

  ngOnInit() {

    this.FormBuild();

    this.ckeditorConfig();

    this.ticketService.getCategories().subscribe(
        (res) => {
          this.data = res;
          this.categories = this.data.categories;
          this.lang = this.ticketService.createLang(res);
        }
    );

    

  }

  FormBuild(): void {

    this.createForm = this.formBuilder.group({
      category: ['', [Validators.required]],
      content: ['', [Validators.required]],
    });

    this.createFormErrorMsg = {
      'category': [{ type: 'required', message: 'This field is Required' }],
      'content': [{ type: 'required', message: 'This field is Required' }],
    }

  }

  ckeditorConfig(): void {
    
    this.ckeditorOptions = {
      plugins: 'dialogui,dialog,a11yhelp,dialogadvtab,basicstyles,bidi,blockquote,notification,button,toolbar,clipboard,panelbutton,panel,floatpanel,colorbutton,colordialog,templates,menu,contextmenu,copyformatting,div,resize,elementspath,enterkey,entities,popup,filetools,filebrowser,find,fakeobjects,flash,floatingspace,listblock,richcombo,font,format,horizontalrule,htmlwriter,iframe,wysiwygarea,image,indent,indentblock,indentlist,smiley,justify,menubutton,language,link,list,liststyle,magicline,maximize,newpage,pagebreak,pastetext,pastefromword,preview,removeformat,save,selectall,showblocks,showborders,sourcearea,specialchar,scayt,stylescombo,tab,table,tabletools,tableselection,undo,lineutils,widgetselection,widget,notificationaggregator,uploadwidget,uploadimage,wsc',
      div_wrapTable: true,
      extraPlugins: 'tableresize',
      height: 350,
      filebrowserBrowseUrl: 'http://localhost:8081/projects/kaizen/assets/plugins/ckfinder/ckfinder.html',
      filebrowserImageBrowseUrl: 'http://localhost:8081/projects/kaizen/assets/plugins/ckfinder/ckfinder.html?Type=Images',
      filebrowserUploadUrl: 'http://localhost:8081/projects/kaizen/assets/plugins/ckfinder/core/connector/php/connector.php?command=QuickUpload&type=Files',
      filebrowserImageUploadUrl: 'http://localhost:8081/projects/kaizen/assets/plugins/ckfinder/core/connector/php/connector.php?command=QuickUpload&type=Images',
      filebrowserWindowWidth: '1000',
      filebrowserWindowHeight: '700',
    };

  }

  formErrorClass(value, submitted): string {
    return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }

  createFormSubmit(): void {

    this.createFormSubmitted = true;

    if (this.createForm.invalid)
      return;

    this.ticketService.createTicket(this.createForm.value)
      .subscribe(
        (res) => {

          if (res.status) {
            this.generalService.notify_msg('success', res.msg);
            
            this.router.navigateByUrl('/test', { skipLocationChange: true })
              .then(() => {
                this.router.navigate([AppFrontRoutes.TICKET_VIEW+'/'+res.data.ticket_id]);
            });
          }
          else
            this.generalService.notify_msg('error', res.msg);

      });

  }

}